import { render, staticRenderFns } from "./PotentialHighNetWorthDataTable.vue?vue&type=template&id=224b3c64&scoped=true"
import script from "./PotentialHighNetWorthDataTable.vue?vue&type=script&lang=js"
export * from "./PotentialHighNetWorthDataTable.vue?vue&type=script&lang=js"
import style0 from "./PotentialHighNetWorthDataTable.vue?vue&type=style&index=0&id=224b3c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b3c64",
  null
  
)

export default component.exports